// extracted by mini-css-extract-plugin
export default {"legacy":"SettingsLegacy_legacy__9Ujps","dialog":"SettingsLegacy_dialog__6B73M"};